import React from "react";
import { Field } from "redux-form";

import { planList } from "../../../../helpers/list";
import { formatAmount } from "../../../../helpers/format";
import Title from "../../../../components/Title";
import Editor from "../../../../components/Editor";
import Radio from "../../../../components/Field/Radio";
import AsyncGet from "../../../../components/AsyncGet";

import style from "../style.module.css";

export default function PlanList(props) {
    const {
        userplan = null,
        setuserplan = () => {},
        urlplan = "",
        setUrlPlan = '',
        setPlanId = '',
        setPlanType = '',
    } = props;

    return (
        <AsyncGet
            url="/list/plans"
            permissionText="Plans"
            loadOnMount={true}
            render={({ data }) => {
                if (data.list) {
                    return (
                        <div className={style.planList}>
                            {
                                data.list.length > 0 && data.list.map((item, index) => {
                                    return (
                                        <label 
                                            key={`planListItem${index}`} 
                                            htmlFor={`plan_${item.id}`} 
                                            className={`${style.planListItem}`} 
                                            onClick={() => {
                                                setuserplan(item.id);
                                                setUrlPlan("");
                                                setPlanId(item.id);
                                                setPlanType(item.plan_type);
                                            }}
                                        >
                                            <div className={`${style.planListItemInner}  ${userplan === item.id || urlplan === item.id ? style.planListItemActive : ''}`}>
                                                <div className={style.textDetailsWrap}>
                                                    <Field
                                                        name="plan_id"
                                                        component={Radio}
                                                        label={item.full_title}
                                                        id={`plan_${item.id}`}
                                                        checkedValue={item.id}
                                                    />
                                                    <div className={style.textDetails}>
                                                        <div className={style.planName}>
                                                            <Title tag="p">{item.full_title}</Title>
                                                        </div>
                                                        <Title className="fontTeko" tag="h6">{formatAmount(item.price, "£")} / <span className={style.planType}>{planList()[item.plan_type || '']}</span></Title>
                                                        <Editor text={item.description} />
                                                    </div>
                                                </div>
                                                <div className={style.bestSellerWrap}>
                                                    {
                                                        item.best_seller === 1 && (
                                                            <div className={style.bestSeller}>
                                                                <Title transform="textUpperCase" tag="p">Best Seller</Title>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </label>
                                    )
                                })
                            }
                        </div>
                    )
                }
            }}
        />
    )
}